if (!customElements.get('shoe-lifts-final-cta')) {
  customElements.define('shoe-lifts-final-cta', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href="#shoe-lifts-offer"]');
        const target = document.getElementById('shoe-lifts-offer');
        if (!link || !target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start'
        });
      });
    }
  });
}
